import { Badge, Group, Select, SelectProps, rem } from '@mantine/core'
import { IconCheck } from '@tabler/icons-react'
import { forwardRef } from 'react'

export type LabelOption = {
  value: string
  label: string
  color: string
}

export const ObjectSelect = forwardRef<HTMLInputElement, SelectProps>(
  (props, ref) => {
    return (
      <Select
        size="xs"
        allowDeselect={false}
        maxDropdownHeight={300}
        comboboxProps={{
          width: 320,
          position: 'bottom-start'
        }}
        styles={{
          input: {
            fontSize: rem(12),
            fontWeight: 'bold',
            textTransform: 'uppercase'
          }
        }}
        renderOption={({ option, checked }) => {
          const { label, color } = option as LabelOption

          return (
            <Group flex="1" gap="xs">
              <Badge color={color} size="sm">
                {label}
              </Badge>

              {checked && (
                <IconCheck style={{ marginInlineStart: 'auto' }} size={16} />
              )}
            </Group>
          )
        }}
        {...props}
        ref={ref}
      />
    )
  }
)

ObjectSelect.displayName = 'ObjectSelect'
